import { environment } from '~env/environment';

export class ApiConfig {
  public static readonly CDN_JSON_URL = () => `${environment.cdnBaseUrl()}/json`;
  public static readonly CDN_IMAGE_URL = () => `${environment.cdnBaseUrl()}/images`;
  public static readonly SVC_IMS_API_URL = () => environment.svcImsBaseUrl();
  public static readonly BUYER_REACT_COOKIE_CLEAR_API_URL = () => `${environment.appBaseUrl()}/app-api/logout`;
  public static readonly BUYER_REACT_ORDER_REVIEW_URL = () => `${environment.baseHref()}cart-review`;
  public static readonly SVC_API_URL = () => `${environment.svcCheckoutBaseUrl()}/api/v1`;
  public static readonly SVC_API_URL_V2 = () => `${environment.svcCheckoutBaseUrl()}/api/v2`;
  public static readonly SVC_USER_ACCOUNT_API_URL = () => `${environment.svcUserAccountBaseUrl()}/api/v1`;
  public static readonly SVC_BUYER_ACCOUNT_API_URL = () => `${environment.svcBuyerAccountBaseUrl()}/api/v1`;
  public static readonly SVC_PUBLIC_BUYER_ACCOUNT_API_URL = () =>
    `${environment.svcBuyerAccountBaseUrl()}/api/public/v1`;
  public static readonly SVC_BUYER_ACCOUNT_API_V1_URL = () => `${environment.svcBuyerAccountBaseUrl()}/api/account/v1`;
  public static readonly SVC_BUYER_ACCOUNT_API_V2_URL = () => `${environment.svcBuyerAccountBaseUrl()}/api/account/v2`;
  public static readonly IDAM_SSO_ISSUER_WEB_V2 = () => `${environment.IDAMSSO?.()?.issuer}/web/v2`;
  public static readonly SVC_BUYER_ACCOUNT_SEND_MAGIC_LINK_API_URL = () =>
    `${ApiConfig.SVC_BUYER_ACCOUNT_API_URL()}/send-magic-link`;
  public static readonly SVC_BUYER_ACCOUNT_EMPLOYEE_SEARCH_CUSTOMERS_API_URL = () =>
    `${environment.svcBuyerAccountBaseUrl()}/api/employee/v1/employee/customers`;
  public static readonly SVC_BUYER_ACCOUNT_EMPLOYEE_IMPERSONATE_API_URL = () =>
    `${environment.svcBuyerAccountBaseUrl()}/api/employee/v1/employee/impersonation-session`;
  public static readonly SVC_BUYER_ACCOUNT_EMPLOYEE_SHARE_PAYMENT_LINK_API_URL = () =>
    `${environment.svcBuyerAccountBaseUrl()}/api/employee/v1/shared-payment-links`;
  public static readonly BUYER_ACCOUNT_SEND_RESET_PASSWORD_API_URL = () =>
    `${ApiConfig.IDAM_SSO_ISSUER_WEB_V2()}/reset-password`;
  public static readonly SVC_BUYER_ACCOUNT_ADDRESS_SUGGESTIONS_URL = (text?: string) =>
    `${ApiConfig.SVC_PUBLIC_BUYER_ACCOUNT_API_URL()}/address-improver/suggestions${text ? `?query=${text}` : ''}`;
  public static readonly SVC_BUYER_ACCOUNT_ADDRESS_DETAILS_URL = (placeId: string) =>
    `${ApiConfig.SVC_PUBLIC_BUYER_ACCOUNT_API_URL()}/address-improver/${placeId}/details`;
  public static readonly SVC_ORDER_MANAGEMENT_ROOT_API_ENDPOINT = () =>
    `${environment.svcOrderManagementBaseUrl()}/api/v1`;
  public static readonly SVC_ORDER_MANAGEMENT_ROOT_API_ENDPOINT_V2 = () =>
    `${environment.svcOrderManagementBaseUrl()}/api/v2`;
  public static readonly SVC_ORDER_MANAGEMENT_CHECKOUT_API_ENDPOINT = () =>
    `${ApiConfig.SVC_ORDER_MANAGEMENT_ROOT_API_ENDPOINT()}/order-management/checkout`;
  public static readonly SVC_ORDER_MANAGEMENT_USER_ACCOUNT_API_ENDPOINT = () =>
    `${ApiConfig.SVC_ORDER_MANAGEMENT_ROOT_API_ENDPOINT()}/order-management/user-account`;
  public static readonly SVC_ORDER_MANAGEMENT_USER_ACCOUNT_API_ENDPOINT_V2 = () =>
    `${ApiConfig.SVC_ORDER_MANAGEMENT_ROOT_API_ENDPOINT_V2()}/order-management/user-account`;
  public static readonly SVC_BUYER_GATEWAY_URL_API_ENDPOINT = () => environment.serviceBuyerGatewayBaseUrl();
  public static readonly SVC_APP_CART_URL_API_ENDPOINT = () => environment.svcCartBaseUrl();
  public static readonly SVC_BUYER_GATEWAY_URL_API_V2_ENDPOINT = () =>
    `${ApiConfig.SVC_BUYER_GATEWAY_URL_API_ENDPOINT()}/api/account/proxy/sobs/v2`;
  public static readonly SVC_BUYER_GATEWAY_URL_API_V3_ENDPOINT = () =>
    `${ApiConfig.SVC_BUYER_GATEWAY_URL_API_ENDPOINT()}/api/account/proxy/sobs/v3`;
  public static readonly SVC_BUYER_GATEWAY_ORDERS_MANAGEMENT_URL_API_ENDPOINT_V3 = () =>
    `${ApiConfig.SVC_BUYER_GATEWAY_URL_API_V3_ENDPOINT()}/orders`;
  public static readonly SVC_CHECKOUT_ORDERS = () => `${ApiConfig.SVC_API_URL}/orders`;
  public static readonly SVC_METRONOM_CSS_PROXY_BASE = () =>
    `${environment.baseHref() || '/'}buyer-account/self-service`;
  public static readonly SVC_IMS_ENDPOINT = () => `${environment.svcImsBaseUrl()}`;
  public static readonly SVC_METRONOM_CSS = () => `${environment.metronomCSSBaseUrl()}`;
  public static readonly SVC_ACCOUNT_INFO_FLYOUT_REFRESH_ENDPOINT = () =>
    [
      environment.metroAppsBaseUrl(),
      '/data/apps/metro?sc_device=partial&components=user profile&forceRefresh=1&timestamp=',
      Date.now(),
    ].join('');
  public static readonly SVC_CRM_EVENTS_URL = () => `${environment.svcCrmBaseUrl()}/api/v1/public/exponea/customers`;
  public static readonly SVC_BUYER_ACCOUNT_BRANCHES_ENDPOINT_V2 = (taxNumber: string) =>
    `${ApiConfig.SVC_BUYER_ACCOUNT_API_V2_URL()}/business/branches?taxNumber=${taxNumber}`;
  public static readonly SVC_BUYER_ACCOUNT_SELECTED_BRANCH_DATA_ENDPOINT_V2 = (vatId: string, branchNumber: string) =>
    `${ApiConfig.SVC_BUYER_ACCOUNT_API_V2_URL()}/business/legal-details?vatId=${vatId}&branchNumber=${branchNumber}`;
  public static readonly SVC_BUYER_ACCOUNT_SELECTED_BRANCH_DATA_FROM_RSIN_ENDPOINT_V2 = (vatId: string) =>
    `${ApiConfig.SVC_BUYER_ACCOUNT_API_V2_URL()}/business/legal-details?vatId=${vatId}`;
  public static readonly SVC_STORAGE_BUCKET_URL = () => `${environment.svcStorageBucketUrl()}`;
  // this url should be removed
  public static readonly SVC_BUY_AGAIN_PRODUCT_LIST_URL = () =>
    `${environment.svcOrderBuyerSearchBaseUrl()}/api/v1/user-account/buy-it-again`;
  public static readonly SBG_BUY_AGAIN_PRODUCT_LIST_URL = () =>
    `${ApiConfig.SVC_BUYER_GATEWAY_URL_API_V2_ENDPOINT()}/buy-it-again`;
}
